import { FC } from 'react'

import { useManualTask } from 'Automations/watchtower/inbox/manualTasks/hooks/useManualTask'
import { TaskInput } from './types'
import { useInvoiceData } from '../../hooks/useInvoiceData'
import { NotificationHeader } from '../../components/NotificationHeader'

export const InvoiceEmailFailedHeader: FC<{
  taskId: string
}> = ({ taskId }) => {
  const { manualTask } = useManualTask({ taskId })
  const { invoice, customer } = useInvoiceData(
    (manualTask?.input as TaskInput | undefined)?.invoiceId
  )

  return (
    <NotificationHeader
      data-testid="watchtower.notification.invoiceEmailFailed.header"
      customer={customer}
      identifier={invoice?.invoiceNumber}
      title="Invoice failed to send"
    />
  )
}
